var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-autocomplete', {
    ref: "autoComplete",
    attrs: {
      "popper-class": "my-autocomplete",
      "placeholder": "请输入详细地址内容",
      "fetch-suggestions": _vm.searchAddress
    },
    on: {
      "select": _vm.handleSelect
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.showContent(item.address),
            "placement": "top"
          }
        }), _c('span', {
          staticClass: "addr"
        }, [_vm._v(_vm._s(item.name)), (_vm.showContent(item.address)) ? _c('span', [_vm._v("(" + _vm._s(_vm.showContent(item.address)) + ")")]) : _vm._e()])]
      }
    }]),
    model: {
      value: (_vm.addressStr),
      callback: function($$v) {
        _vm.addressStr = $$v
      },
      expression: "addressStr"
    }
  }, [_c('i', {
    staticClass: "el-icon-edit el-input__icon",
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  })])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c0697a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c0697a0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AmapSelector/index.vue
// module id = OE7p
// module chunks = 1